import { render, staticRenderFns } from "./ShowIcon.vue?vue&type=template&id=6d67b87a&scoped=true"
import script from "./ShowIcon.vue?vue&type=script&lang=ts"
export * from "./ShowIcon.vue?vue&type=script&lang=ts"
import style0 from "./ShowIcon.scss?vue&type=style&index=0&id=6d67b87a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d67b87a",
  null
  
)

export default component.exports